import {
  Box,
  Button,
  Divider,
  Group,
  LoadingOverlay,
  Select,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useEffect, useRef } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import Repository from "../../../_base/helper/HttpHelper";

const UpdateStatus = function ({
  id,
  status,
  onSearch,
}: {
  id: string;
  status: string;
  onSearch: () => void;
}) {
  //
  const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const selectRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!id) {
      NotificationExtension.Fails("Bạn chưa chọn dữ liệu để cập nhật !");
      modals.closeAll();
    }
    return () => {};
  }, []);

  const form = useForm<any>({
    initialValues: {
      status: status,
    },
  });

  // Danh sách trạng thái có thể cập nhật với màu sắc
  const statusOptions = [
    { value: "chodanhgia", label: "Chờ đánh giá" },
    { value: "phuhop", label: "Phù hợp" },
    { value: "phongvan", label: "Đang phỏng vấn" },
    { value: "dagui", label: "Đã gửi offer" },
    { value: "datuyen", label: "Đã tuyển" },
    { value: "khongphuhop", label: "Không phù hợp" },
  ];

  // // Hàm lấy màu theo trạng thái
  // const getStatusColor = (statusValue: string) => {
  //   const statusOption = statusOptions.find(
  //     (option) => option.value === statusValue
  //   );
  //   return statusOption?.color || "#6c757d";
  // };

  const apiUpdate = async (id: string, newStatus: string) => {
    open();

    if (!id) {
      NotificationExtension.Fails("Mã không tồn tại !");
      close();
      return;
    }

    if (!newStatus) {
      NotificationExtension.Fails("Vui lòng chọn trạng thái !");
      close();
      return;
    }

    if (status === newStatus) {
      NotificationExtension.Fails("Bạn chưa thay đổi trạng thái !");
      close();
      return;
    }

    try {
      const requestData = {
        Ids: [id],
        Status: newStatus,
      };

      const response = await repository.post(
        `/TblTuyenDung/edit-status`,
        requestData
      );

      if (response && response.success) {
        NotificationExtension.Success("Cập nhật trạng thái thành công !");

        // Đóng select dropdown nếu đang mở
        if (selectRef.current) {
          selectRef.current.blur();
        }

        modals.closeAll();
        onSearch();
      }
    } catch (error) {
      NotificationExtension.Fails("Cập nhật trạng thái thất bại !");
    } finally {
      close();
    }
  };

  const formCreate = (
    <>
      <Box
        className="flex-none"
        component="form"
        mx="auto"
        onSubmit={form.onSubmit(async (e: any) => {
          await apiUpdate(id, form.values.status);
        })}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Select
          ref={selectRef}
          size="sm"
          placeholder="Chọn trạng thái..."
          data={statusOptions.map((option) => ({
            value: option.value,
            label: option.label,
          }))}
          {...form.getInputProps("status")}
          styles={{
            option: {
              '&[data-selected="true"]': {
                // backgroundColor: getStatusColor(form.values.status),
                color: "white",
              },
              "&:hover": {
                backgroundColor: "#f8f9fa",
              },
            },
            // input: {
            //   color: getStatusColor(form.values.status),
            //   border: `2px solid ${getStatusColor(form.values.status)}`,
            // },
          }}
          renderOption={({ option, checked }) => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "8px 12px",
                // color: statusOptions.find((s) => s.value === option.value)
                //   ?.color,
                fontWeight: checked ? 600 : 400,
                // backgroundColor: checked
                //   ? `${
                //       statusOptions.find((s) => s.value === option.value)?.color
                //     }20`
                //   : "transparent",
              }}
            >
              {/* <div
                style={{
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  // backgroundColor: statusOptions.find(
                  //   (s) => s.value === option.value
                  // )?.color,
                  // marginRight: 8,
                }}
              /> */}
              {option.label}
            </div>
          )}
          onChange={(value) => {
            form.setFieldValue("status", value);
            // Tự động cập nhật khi chọn trạng thái mới
            if (value && value !== status) {
              apiUpdate(id, value);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              form.onSubmit(async (e: any) => {
                await apiUpdate(id, form.values.status);
              })();
            }
          }}
        />

        {/* <Group justify="flex-end" mt="lg">
          <Button
            type="submit"
            color="#3598dc"
            leftSection={<IconCheck size={18} />}
          >
            Cập nhật
          </Button>

          <Button
            variant="outline"
            color="black"
            type="button"
            onClick={() => modals.closeAll()}
            leftSection={<IconX size={18} />}
          >
            Đóng
          </Button>
        </Group> */}
      </Box>
    </>
  );
  return <>{formCreate}</>;
};

export default UpdateStatus;
